import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=926a3b44&scoped=true&"
import script from "./Asignacion.vue?vue&type=script&lang=ts&"
export * from "./Asignacion.vue?vue&type=script&lang=ts&"
import style0 from "./Asignacion.vue?vue&type=style&index=0&id=926a3b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926a3b44",
  null
  
)

export default component.exports